import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CategoryManage from './pages/CategoryManage';
import OpenmarketMatching from './pages/OpenmarketMatching';
import CategoryNotification from './pages/CategoryNotification';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import AlimtalkLog from './pages/AlimtalkLog';
import Products from './pages/Products';
import ProductSend from './pages/ProductSend';
import ProductRegister from './pages/ProductRegister';
import ProductRegisterBulk from './pages/ProductRegisterBulk';
import ProductMatchRegister from './pages/ProductMatchRegister';
import Sales from './pages/Sales';
import Finance from './pages/Finance';
import Layout from './components/Layout';
import MobileLogin from './pages/mobile/MobileLogin';
import MobileHome from './pages/mobile/MobileHome';
import MobileInvoice from './pages/mobile/MobileInvoice';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

// 모바일 전용 - PC 인증(token)과 완전히 분리된 별도 키(mobile_token) 사용
function MobilePrivateRoute({ children }) {
  const token = localStorage.getItem('mobile_token');
  return token ? children : <Navigate to="/m/login" />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/m/login" element={<MobileLogin />} />
        <Route path="/m" element={<MobilePrivateRoute><MobileHome /></MobilePrivateRoute>} />
        <Route path="/m/invoice" element={<MobilePrivateRoute><MobileInvoice /></MobilePrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/categories" element={<PrivateRoute><Layout><CategoryManage /></Layout></PrivateRoute>} />
        <Route path="/categories/openmarket-matching" element={<PrivateRoute><Layout><OpenmarketMatching /></Layout></PrivateRoute>} />
        <Route path="/categories/notification" element={<PrivateRoute><Layout><CategoryNotification /></Layout></PrivateRoute>} />
        <Route path="/orders" element={<PrivateRoute><Layout><Orders /></Layout></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><Layout><Products /></Layout></PrivateRoute>} />
        <Route path="/products/send" element={<PrivateRoute><Layout><ProductSend /></Layout></PrivateRoute>} />
        <Route path="/products/register" element={<PrivateRoute><Layout><ProductRegister /></Layout></PrivateRoute>} />
        <Route path="/products/register/bulk" element={<PrivateRoute><Layout><ProductRegisterBulk /></Layout></PrivateRoute>} />
        <Route path="/products/register/match" element={<PrivateRoute><ProductMatchRegister /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Layout><Settings /></Layout></PrivateRoute>} />
        <Route path="/alimtalk" element={<PrivateRoute><Layout><AlimtalkLog /></Layout></PrivateRoute>} />
        <Route path="/sales" element={<PrivateRoute><Layout><Sales /></Layout></PrivateRoute>} />
        <Route path="/finance" element={<PrivateRoute><Layout><Finance /></Layout></PrivateRoute>} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
